import styles from "./styles.module.scss";
import classNames from "classnames";
import Star from "@assets/icons/Star";
import ProductCode from "@components/ProductCode";
import CheckIcon from "@assets/icons/CheckIcon.svg";

export const SearchList = ({
  searchResults,
  selectedProductToCompare,
  handleSelect,
}) => {
  return (
    <div className={styles.searchList}>
      {searchResults.slice(0, 5).map((item) => (
        <div key={item.asin} className={styles.productCard}>
          <img
            src={item.image_link}
            alt={item.item_name}
            className={styles.productCard__image}
          />
          <h3>{item.item_name}</h3>
          <div className={styles.rating}>
            <Star />
            <span>4.5</span>
          </div>
          <ProductCode code={item?.asin ?? ""} />
          <button
            className={classNames(styles.btnSelect, {
              [styles.selected]: selectedProductToCompare.some(
                (p) => p.asin === item.asin,
              ),
            })}
            onClick={() => handleSelect(item)}
          >
            {selectedProductToCompare.some((p) => p.asin === item.asin) && (
              <img src={CheckIcon} alt="checked" />
            )}
            select
          </button>
        </div>
      ))}
    </div>
  );
};
